// extracted by mini-css-extract-plugin
export var chip = "_4c-0";
export var filterDropdown = "_4c-5";
export var filterItem = "_4c-6";
export var icon = "_4c-1";
export var removeButton = "_4c-3";
export var removeIcon = "_4c-4";
export var separator = "_4c-2";